import { useTransaction } from "hooks/useTransactions";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as comexActions } from "reducers/comex";
import { bool } from "prop-types";
import Button from "pages/_components/Button";
import Dropdown from "pages/_components/Dropdown";
import { DesktopButtons, ResponsiveHeader } from "pages/_components/header";
import * as configUtils from "util/config";
import { useIsSignerPending } from "hooks/useIsSignerPending";
import ComexSummaryBody from "./_components/SummaryBody";
import ComexStepper from "./_components/ComexStepper";

const ComexTransferSummaryPage = ({ isDesktop }) => {
    const { comexTransfer = {}, comexId = null } = useSelector((state) => state.comex);
    const { contactDestination = {}, transferData = {}, concept = "" } = comexTransfer;
    const operationType = transferData?.exchangeSale ? "exchangeSale" : "cashCurrencyExchange";
    const dispatch = useDispatch();
    const { isSignerPending } = useIsSignerPending(comexTransfer?.idTransaction);

    const generateComexRequest = {
        ...comexTransfer,
        operationType,
        comexId,
        amount: transferData.amount,
    };

    const isServices = concept.includes("S");
    const isGoods = concept.includes("B");

    const ddjjGeneralCode = configUtils.get(`comex.thuban.code.ddjjFile`);
    let ddjjFileCode = null;

    if (isServices) {
        ddjjFileCode = configUtils.get("comex.thuban.code.ddjjServicesFile");
    } else if (isGoods) {
        ddjjFileCode = configUtils.get("comex.thuban.code.ddjjGoodsFile");
    }

    const handleDownload = (documentCode) => {
        if (comexTransfer?.comexId) {
            dispatch(comexActions.documentDownload(comexTransfer?.comexId, documentCode));
        }
    };

    return (
        <>
            {isDesktop && <ComexStepper isDesktop={isDesktop} currentStep={9} />}

            <Notification scopeToShow="ComexTransferSummaryPage" />
            <ResponsiveHeader id="request.transfers.comex.title">
                {isSignerPending && (
                    <DesktopButtons>
                        <Dropdown
                            image="images/figma/icon/download.svg"
                            label="comex.files.download"
                            buttonClass="btn btn-outline"
                            pullRight
                            widthXl>
                            {ddjjFileCode && (
                                <Button
                                    onClick={() => handleDownload(ddjjFileCode)}
                                    label={isServices ? "comex.ddjj.services.download" : "comex.ddjj.goods.download"}
                                    className="dropdown__item-btn"
                                    bsStyle="link"
                                />
                            )}
                            <Button
                                onClick={() => handleDownload(ddjjGeneralCode)}
                                label="comex.ddjj.general.download"
                                className="dropdown__item-btn"
                                bsStyle="link"
                            />
                            <Button
                                onClick={() => handleDownload("COMEX_CODE")}
                                label="comex.flow.download"
                                className="dropdown__item-btn"
                                bsStyle="link"
                            />
                        </Dropdown>
                    </DesktopButtons>
                )}
            </ResponsiveHeader>
            <MainContainer>
                <I18n id="comex.summary.confirm" component="h3" />
                <ComexSummaryBody
                    originAccountLabel={transferData?.originAccountLabel}
                    ownerName={transferData?.ownerName}
                    ownerCuit={transferData?.ownerCuit}
                    amount={transferData?.amountField}
                    operationType={operationType}
                    concept={concept}
                    contactDestination={contactDestination}
                    foreignCurrency={transferData?.currency}
                />
                <GeneralCredentialForm
                    transactionData={generateComexRequest}
                    action={comexActions.generateTrasnsfer}
                    idActivity="generate.comex.transfer"
                    hideIndications
                    isToken
                />
            </MainContainer>
        </>
    );
};
ComexTransferSummaryPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ComexTransferSummaryPage;
